import {CHANGE_PROFILE} from "../actions";

const profile = (state = {profile: 'foot-hiking'}, action) => {
    switch (action.type) {
        case CHANGE_PROFILE:
            return {
                profile: action.profile
            }
        default:
            return state;
    }
}

export default profile
